export function setParentHeight(height: number): void {
  tellParent("set_iframe_height", `${height}px`);
}

export function camelToSnakeCase(text: string) {
  return text
    .replace(/(.)([A-Z][a-z]+)/, "$1_$2")
    .replace(/([a-z0-9])([A-Z])/, "$1_$2")
    .toLowerCase();
}

export function dehtml(string?: string, removeAsterisks = false) {
  let newString = string || "";
  newString = newString?.replace(/(<([^>]+)>)/gi, " ");
  if (removeAsterisks) newString = newString.replace(/\*\s/, "");
  return newString;
}

/** Converts a Hudson date format string to a date-fns compatible format string.
 *  Hudson formats use VB-style tokens (e.g. "mm" = month, "nn" = minutes).
 *  Replacements are ordered longest-first to prevent partial matches. */
export function hudsonDateFormatToJavascriptFormat(hudsonFormat: string) {
  // Map Hudson tokens to date-fns tokens, longest first within each group
  const replacements: [RegExp, string][] = [
    [/HHmm/i, "h:mm"],
    [/HH:mm/i, "h:mm"],
    [/hh/i, "hh"],
    [/(AM)|(PM)/i, "b"],
    [/A|P/i, "b"],
    [/dddd/i, "eeee"],
    [/ddd/i, "eee"],
    [/dd/i, "d"],
    [/mmmm/i, "MMMM"],
    [/mmm/i, "MMM"],
    [/mm/i, "M"],
    [/nn/i, "mm"],
    [/ss/i, "ss"],
    [/yyyy/i, "yyyy"],
    [/yy/i, "yy"],
    [/ww/i, "ww"],
  ];

  // Use placeholder tokens during replacement to prevent re-matching.
  // Each replacement gets a unique placeholder like \x00_0\x00, \x00_1\x00, etc.
  const placeholders: string[] = [];
  let result = hudsonFormat;

  for (let i = 0; i < replacements.length; i++) {
    const [pattern, replacement] = replacements[i];
    const placeholder = `\x00_${i}\x00`;
    if (pattern.test(result)) {
      placeholders[i] = replacement;
      result = result.replace(pattern, placeholder);
    }
  }

  // Restore placeholders with their final values
  for (let i = 0; i < replacements.length; i++) {
    if (placeholders[i] !== undefined) {
      result = result.replace(`\x00_${i}\x00`, placeholders[i]);
    }
  }

  return result;
}

const inParentFrame = () => global?.window?.self != global?.window?.parent;

export function isMobile(breakpointPx = 1079): boolean {
  return global?.window?.matchMedia(`screen and (max-width: ${breakpointPx}px)`)
    .matches;
}

export function parentRedirect(url: string): void {
  if (inParentFrame()) {
    tellParent("page_redirect", url.replace(/=/g, "%3D"));
  } else {
    window.location.href = url;
  }
}

export const parentScrollToTheTop = (): void => {
  tellParent("scroll_to_top_of_frame", 0);
};

export function scrollToElement(element: HTMLElement): void {
  element?.scrollIntoView({
    behavior: "smooth",
    block: "end",
    inline: "nearest",
  });
}

function tellParent(key: string, value: string | number): void {
  if (!inParentFrame()) return;
  window.parent.window.postMessage(`${key}=${value}`, "*");
}
